export var CustomerStatus;
(function (CustomerStatus) {
    CustomerStatus["ACTIVE"] = "ACTIVE";
    CustomerStatus["INACTIVE"] = "INACTIVE";
    CustomerStatus["PENDING"] = "PENDING";
    CustomerStatus["DELETED"] = "DELETED";
    CustomerStatus["PURGED"] = "PURGED";
})(CustomerStatus || (CustomerStatus = {}));
export var Gender;
(function (Gender) {
    Gender["MALE"] = "MALE";
    Gender["FEMALE"] = "FEMALE";
    Gender["OTHER"] = "OTHER";
    Gender["PREFER_NOT_TO_SAY"] = "PREFER_NOT_TO_SAY";
})(Gender || (Gender = {}));
// ID Type enum
export var IdType;
(function (IdType) {
    IdType["CPF"] = "CPF";
    IdType["RG"] = "RG";
    IdType["PASSPORT"] = "PASSPORT";
})(IdType || (IdType = {}));
// Helper types for gender and status display
export const GENDER_LABELS = {
    [Gender.MALE]: "Male",
    [Gender.FEMALE]: "Female",
    [Gender.OTHER]: "Other",
    [Gender.PREFER_NOT_TO_SAY]: "Prefer not to say",
};
export const CUSTOMER_STATUS_LABELS = {
    [CustomerStatus.ACTIVE]: "Active",
    [CustomerStatus.INACTIVE]: "Inactive",
    [CustomerStatus.PENDING]: "Pending",
    [CustomerStatus.DELETED]: "Deleted",
    [CustomerStatus.PURGED]: "Purged",
};
export const ID_TYPE_LABELS = {
    [IdType.CPF]: "CPF",
    [IdType.RG]: "RG",
    [IdType.PASSPORT]: "Passport",
};
// Helper function to get full name
export const getCustomerFullName = (customer) => {
    return `${customer.firstName} ${customer.lastName}`.trim();
};
// Helper function to get display name with ID
export const getCustomerDisplayName = (customer) => {
    const fullName = getCustomerFullName(customer);
    if (customer.idNumber) {
        return `${fullName} (${customer.idNumber})`;
    }
    return fullName;
};
//# sourceMappingURL=Customer.js.map